import { FunctionComponent, useEffect } from 'react'

import { Grid } from '@theme-ui/components'
import { shallowEqual } from 'react-redux'

import styled from 'styled-components'

import { Spinner, Text } from '@fairhq/common'
import { useTitle } from 'features/assessmentQuestions/hooks/useTitle'
import { useAreas } from 'hooks/useAreas'
import { useUpdateIntercomAuditCompletion } from 'hooks/useUpdateIntercomAuditCompletion'
import { getAreas } from 'store/area/areaSlice'
import { AreaType } from 'store/area/types'
import { State } from 'store/state'

import { Layout } from '../../layout/Layout'
import { PageTop } from '../../layout/PageTop'

import { useAppDispatch, useAppSelector } from '../../store/hooks'

import { SubArea } from './SubArea'

const CenteredSpinner = styled.div`
  display: flex;
  justify-content: center;
`
export const Assessment: FunctionComponent = () => {
  const dispatch = useAppDispatch()
  const { loading, areas } = useAppSelector(
    (state: State) => ({
      areas: state.areaReducer.areas || [],
      loading: state.areaReducer.loading,
    }),
    shallowEqual
  )

  const { title, percent } = useTitle()
  useUpdateIntercomAuditCompletion()

  useAreas({})

  useEffect(() => {
    if (!loading && areas?.length === 0) {
      dispatch(getAreas({}))
    }
  })

  const content = areas?.filter(area => area.type === AreaType.SUB)

  return (
    <Layout dark>
      <PageTop>
        <Text fontWeight={700} size="xl" element="h1" type="heading">
          {title}
        </Text>
        <Text fontWeight={600} size="lg" element="h1" type="heading">
          {percent}%
        </Text>
      </PageTop>

      {loading && (
        <CenteredSpinner>
          <Spinner />
        </CenteredSpinner>
      )}

      {!loading && content.length > 0 && (
        <Grid columns={content.length < 5 ? 1 : 2} gap={4} sx={{ rowGap: 2 }}>
          {content.map(({ code, title }) => (
            <SubArea key={code} code={code} label={title} />
          ))}
        </Grid>
      )}
    </Layout>
  )
}
